import snakecaseKeys from 'snakecase-keys'
import { pick } from 'lodash'
import { page, track } from '../analytics'

const getArgs = args => {
  return pick(args, [
    'workspaceId',
    'workspaceSlug',
    'audienceId',
    'audienceName',
    'isAudienceRealtime'
  ])
}

export const personasAudienceViewed = args => {
  page('Personas Audience Viewed', getArgs(args))
}

export const personasAudiencePreviewSucceeded = args => {
  const trackArgs = pick(args, [
    'workspaceId',
    'workspaceSlug',
    'astDefinition',
    'runId',
    'isAudienceRealtime'
  ])

  if (args.audienceId) {
    Object.assign(trackArgs, pick(args, 'audienceId'))
  }

  if (args.audienceName) {
    Object.assign(trackArgs, pick(args, 'audienceName'))
  }

  track('Personas Audience Preview Succeeded', trackArgs)
}

export const personasAudiencePreviewFailed = args => {
  const trackArgs = pick(args, [
    'workspaceId',
    'workspaceSlug',
    'astDefinition',
    'isAudienceRealtime'
  ])

  if (args.audienceId) {
    Object.assign(trackArgs, pick(args, 'audienceId'))
  }

  if (args.audienceName) {
    Object.assign(trackArgs, pick(args, 'audienceName'))
  }

  if (args.errorMessage) {
    Object.assign(trackArgs, pick(args, 'errorMessage'))
  }

  if (args.runId) {
    Object.assign(trackArgs, pick(args, 'runId'))
  }

  track('Personas Audience Preview Failed', trackArgs)
}

export const personasAudienceCreated = args => {
  window.analytics.track(
    'Personas Audience Created',
    snakecaseKeys({
      ...getArgs(args),
      ...pick(args, [
        'destinations',
        'destinationCount',
        'templateId',
        'templateName'
      ])
    })
  )
}

export const personasAudienceUpdated = args => {
  track('Personas Audience Updated', {
    ...getArgs(args),
    status: args.status
  })
}

export const personasAudienceDeleted = args => {
  track('Personas Audience Deleted', getArgs(args))
}

export const personasAudienceDestinationsAdded = args => {
  track('Personas Audience Destination Added', {
    ...getArgs(args),
    ...pick(args, ['destinations', 'destinationCount'])
  })
}

export const personasAudienceDestinationUpdated = args => {
  track('Personas Audience Destination Updated', {
    ...getArgs(args),
    ...pick(args, ['type', 'destinationName'])
  })
}

export const personasAudienceDestinationRemoved = args => {
  track('Personas Audience Destination Removed', {
    ...getArgs(args),
    ...pick(args, 'destinationName')
  })
}

export const personasAudienceTemplatesViewed = args => {
  track(
    'Personas Audience Templates Viewed',
    pick(args, ['workspaceId', 'workspaceSlug'])
  )
}

export const personasAudienceTemplateViewed = args => {
  track(
    'Personas Audience Template Viewed',
    pick(args, ['workspaceId', 'workspaceSlug', 'templateId', 'templateName'])
  )
}

export const personasAudienceTemplateRequested = args => {
  track(
    'Personas Audience Template Requested',
    pick(args, ['workspaceId', 'workspaceSlug', 'description'])
  )
}
